
import { Helmet } from 'react-helmet-async';
import { Event } from '@/lib/types';
import { getEventDateRangeString } from '@/lib/eventHelpers';

interface EventMetaTagsProps {
  event: Event;
}

const EventMetaTags = ({ event }: EventMetaTagsProps) => {
  if (!event) return null;
  
  // Generate formatted date for meta description
  const dateRange = getEventDateRangeString(event.dateStart, event.dateEnd);
  
  // Generate a clean description without extra whitespace or markup
  const cleanDescription = event.description
    ? event.description.substring(0, 160).replace(/\s+/g, ' ').trim()
    : '';
  
  // Create meta description with essential event information
  const metaDescription = `${event.name} - ${dateRange}${event.venue ? ` | ${event.venue.online ? 'Online' : event.venue.city}` : ''}. ${cleanDescription}`;
  
  // Determine canonical URL
  const eventIdentifier = event.slug || event.code || event.id;
  const canonicalUrl = `${window.location.origin}/event/${eventIdentifier}`;

  return (
    <Helmet>
      <title>{`${event.name} | MediHub`}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={`${event.name} | MediHub`} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="event" />
      <meta property="og:url" content={canonicalUrl} />
      {event.imageUrl && <meta property="og:image" content={event.imageUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${event.name} | MediHub`} />
      <meta name="twitter:description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default EventMetaTags;
